import { makeAutoObservable } from "mobx";
import { ApiResponse, IRootStore } from "..";
import Api from "../../services/api";
import { ApiConfig } from "../../services/api-config";
import _ from "lodash";
import { IAddress } from "../cart";
import { ShowAlert } from "../../utils/functions";

export default class UserStore {
  users: Array<IUserCommand> = [];
  editUser: IUserCommand | null = null;
  userAddress?: IAddress;
  userDetails: IUserCommand | null = null;
  private rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  fetchUsers = () => {
    const url = ApiConfig.REST_URIS.user.fetchAll;
    Api.get(url, (res: ApiResponse<IUserCommand[]>) => {
      if (res?.isSuccess && res.data) {
        this.users = _.sortBy(res.data, "firstName");
      }
    });
  };

  getUserDetails = (userId: string) => {
    const url = ApiConfig.REST_URIS.user.getById(userId);
    Api.get(url, (res: ApiResponse<IUserCommand>) => {
      if (res?.isSuccess && res.data) {
        this.userDetails = res.data;
      }
    });
  };

  createUser = (user: IUserCommand, callback: Function) => {
    Api.post(
      ApiConfig.REST_URIS.user.create,
      user,
      (res: ApiResponse<boolean>) => {
        callback && callback(res?.isSuccess && res.data);
      }
    );
  };

  updateUser = (user: IUserCommand, callback: Function) => {
    Api.put(
      ApiConfig.REST_URIS.user.update(user.id),
      user,
      (res: ApiResponse<boolean>) => {
        callback && callback(res?.isSuccess && res.data);
      }
    );
  };

  deleteUser = (id: string, callback: Function) => {
    const url = ApiConfig.REST_URIS.user.delete(id);

    Api.delete(url, (res: ApiResponse<boolean>) => {
      callback && callback(res?.isSuccess && res.data);
    });
  };

  setEditUser = (user: IUserCommand | null) => {
    this.editUser = user;
  };

  getUserAddress = (userId: string) => {
    const url = ApiConfig.REST_URIS.order.getUserAddress(userId);
    Api.get(url, (res: ApiResponse<IAddress>) => {
      if (res?.isSuccess && res.data) {
        this.userAddress = res.data;
      }
    });
  };

  saveUserProfile = (
    userId: string,
    firstName: string,
    surname: string,
    phoneNumber: string,
    address: IAddress,
    callback: Function
  ) => {
    Api.post(
      ApiConfig.REST_URIS.user.saveProfile(userId),
      { userId, firstName, surname, phoneNumber, address },
      (res: ApiResponse<boolean>) => {
        if (res?.isSuccess && res.data)
          ShowAlert.Success("Account information updated successfully.");
        else ShowAlert.Error("Request failed. Please try again.");
        callback && callback(res?.isSuccess && res.data);
      }
    );
  };

  changePassword = (
    currentPassword: string,
    newPassword: string,
    callback: Function
  ) => {
    Api.put(
      ApiConfig.REST_URIS.user.changePassword,
      { currentPassword, newPassword, ConfirmNewPassword: newPassword },
      (res: ApiResponse<boolean>) => {
        callback && callback(res);
      }
    );
  };

  changePasswordByUserId = (
    userId: string,
    newPassword: string,
    callback: Function
  ) => {
    Api.put(
      ApiConfig.REST_URIS.user.changePasswordByUserId,
      { userId, newPassword },
      (res: ApiResponse<boolean>) => {
        callback && callback(res);
      }
    );
  };
}
